import React from "react";
import { motion } from "framer-motion";
import { Clock, TrendingDown, Shield } from "lucide-react";

/**
 * PillarsBand — section piliers (Temps / Argent / Tranquillité) sur fond uni
 * clair #F9F9F7, juste APRÈS le Hero (plus collée à la photo).
 *
 *  • Plus d'espace, icônes minimalistes Lucide
 *  • Texte noir mat #1A1A1A
 *  • Séparateurs verticaux fins #E0E0E0 en desktop
 *  • Esprit luxe accessible, inspiration Kretz Real Estate
 */
const PILLARS = [
  {
    k: "Temps",
    v: "Gagnez des heures de recherche et de démarches.",
    Icon: Clock,
  },
  {
    k: "Argent",
    v: "Des économies réelles sur vos contrats.",
    Icon: TrendingDown,
  },
  {
    k: "Tranquillité",
    v: "Un interlocuteur unique pour toute votre vie.",
    Icon: Shield,
  },
];

export default function PillarsBand() {
  return (
    <section
      data-testid="pillars-band"
      className="bg-[#F9F9F7] py-20 md:py-28"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-20">
        <div className="grid grid-cols-1 md:grid-cols-3 md:divide-x md:divide-[#E0E0E0]">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.k}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              data-testid={`pillar-${p.k.toLowerCase()}`}
              className="px-4 md:px-12 py-8 md:py-4 text-center md:text-left"
            >
              <div className="inline-flex h-10 w-10 items-center justify-center text-[#1A1A1A]">
                <p.Icon className="h-5 w-5" strokeWidth={1.25} />
              </div>
              <div className="mt-5 font-serif text-3xl md:text-4xl tracking-tight text-[#1A1A1A]">
                {p.k}
              </div>
              <p className="mt-3 text-[#1A1A1A]/65 text-sm md:text-[15px] font-light leading-relaxed max-w-[280px] mx-auto md:mx-0">
                {p.v}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
